import React from 'react'
import { Carousel, Modal } from 'react-bootstrap'
import styled from 'styled-components'
import Agenda1 from '../../images/event/agenda-01.jpg'
import Agenda2 from '../../images/event/agenda-02.jpg'
import { COLORS, SIZES } from '../../styles/theme'

const StyledModal = styled(Modal)`
  .modal-content {
    box-shadow: 0px 4px 12px ${COLORS.lightGray1};
  }
  .modal-body {
    padding: 0;
  }
`

const StyledCarousel = styled(Carousel)`
  .carousel-control-next,
  .carousel-control-prev {
    opacity: 1;
  }

  .carousel-control-prev {
    left: -10%;
    ${SIZES.mobile} {
      left: -5%;
    }
  }
  .carousel-control-next {
    right: -10%;
    ${SIZES.mobile} {
      right: -5%;
    }
  }
`

const agendaList = [
  {
    id: 1,
    image: Agenda1,
  },
  {
    id: 2,
    image: Agenda2,
  },
]

export default function SpeakersModal({ showModal, hideSchedule }) {
  return (
    <StyledModal show={showModal} onHide={hideSchedule} size="lg" aria-labelledby="speakers-bio" centered>
      <Modal.Body>
        <StyledCarousel>
          {agendaList.map((agenda, index) => (
            <Carousel.Item key={`agenda-${index}`} interval={4000}>
              <img className="d-block w-100" src={agenda.image} alt={`agenda-${index}`} />
            </Carousel.Item>
          ))}
        </StyledCarousel>
      </Modal.Body>
    </StyledModal>
  )
}
